import { SnColorPalette } from '@lib/common/types';
import { SnRouteConfig } from '@lib/state/router';
import { SnBadgeConfig } from '@lib/ui/badge';
import { SnIconConfig } from '@lib/ui/icon';
import { SnMenuConfig } from '@lib/ui/menu';

import { SnActionClickHandler } from './action-click-handler.type';
import { SnActionDisableExpression } from './action-disable-expression.type';
import { SnActionHideExpression } from './action-hide-expression.type';

interface ISnActionConfig<D> {
  label: string | (() => string);
  class?: string | (() => string);
  badge?: SnBadgeConfig;
  icon?: SnIconConfig;
  route?: SnRouteConfig;
  menu?: SnMenuConfig;
  color?: SnColorPalette;
  collapse?: boolean | string;
  click?: SnActionClickHandler<D>;
  hidden?: boolean | SnActionHideExpression<D>;
  disabled?: boolean | SnActionDisableExpression<D>;
}

export type SnActionConfig<D = any> = ISnActionConfig<D>;
